// extracted by mini-css-extract-plugin
export default {"card":"alertmessage_card__LvU7L","closebutton":"alertmessage_closebutton__WcEf5"};